<template>
  <div
    class="ta-condition-report-request-wrapper"
    v-if="isVisible"
  >
    <ConditionReportRequestModal />
    <b-button
      variant="primary"
      class="ta-condition-report-request-button"
      @click="showModal"
    >
      {{ $t('Request Condition Report') }}
    </b-button>
    <div
      class="ta-user-condition-report-requests-info"
      v-if="lot.lot_condition_report_requests_count"
    >
      {{ $t('You have already sent {value} condition report requests for this lot.', {value: lot.lot_condition_report_requests_count}) }}
      <router-link
        :to="{ name: 'MyConditionReportRequests' }"
        class="text-sm"
      >
        {{ $t('Click here to view.') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import ConditionReportRequestModal from "@/components/condition-report/ConditionReportRequestModal.vue";

export default {
  name: "ConditionReportRequest",
  components: {
    ConditionReportRequestModal,
  },
  computed: {
    ...mapState({
      conditionReportModal: state => state.lotObject.conditionReportModal,
      lot: state => state.lotObject.data,
    }),
    ...mapGetters(['is_authorized', 'customerMeta']),
    isVisible () {
      if (this.lot.auction.status !== 'published') return false
      if (this.is_authorized && this.customerMeta && this.customerMeta.block_requesting_condition_reports) return false

      switch (this.lot.allow_webapp_condition_report_requests) {
        case 'allow_all':
          return true
        case 'allow_registered':
          return this.is_authorized
        default:
          return false
      }
    }
  },
  methods: {
    ...mapMutations(['setShowConditionReportModal']),
    showModal () {
      this.setShowConditionReportModal(true)
    }
  }
}
</script>

<style>
.ta-user-condition-report-requests-info {
  font-size: 0.875rem;
}
.ta-condition-report-request-button {
  display: block;
  width: 100%;
}
</style>
